import { Stack, TextInput } from 'component-library';
import { useTranslation } from 'react-i18next';

import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components';
import {
  useWorkstreamCreateContext,
  WORKSTREAM_FORM_KEYS,
} from '@/pages/shared/workstreams/pages/hooks/useFormControls';

export const WorkstreamFormInfo = ({ form }: { form: ReturnType<typeof useWorkstreamCreateContext> }) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={6} className='rounded-lg border border-divider p-6'>
      <FormField
        control={form.control}
        name={WORKSTREAM_FORM_KEYS.TITLE}
        rules={{ required: true }}
        render={({ field: { value, ...field } }) => (
          <FormItem className='flex flex-col gap-2'>
            <FormLabel className='typography-overline text-text-secondary'>
              {t('global.workstream.labels.title')}
            </FormLabel>
            <FormControl>
              <TextInput value={value} placeholder={t('global.workstream.placeholders.title')} {...field} />
            </FormControl>
            <FormDescription>{t('global.workstream.hints.title')}</FormDescription>
            <FormMessage>{form.formState.errors.title?.message}</FormMessage>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name={WORKSTREAM_FORM_KEYS.DESCRIPTION}
        render={({ field: { value, ...field } }) => (
          <FormItem className='flex flex-col gap-2'>
            <FormLabel className='typography-overline text-text-secondary'>
              {t('global.workstream.labels.description')}
            </FormLabel>
            <FormControl>
              <textarea
                value={value}
                placeholder={t('global.workstream.placeholders.description')}
                rows={2}
                className='typography-body1 w-full resize-y rounded border border-divider bg-transparent px-3 py-2 text-text-primary placeholder:text-text-disabled focus:outline-none focus:ring-1 focus:ring-primary-100'
                {...field}
              />
            </FormControl>
            <FormDescription>{t('global.workstream.hints.description')}</FormDescription>
            <FormMessage>{form.formState.errors.description?.message}</FormMessage>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name={WORKSTREAM_FORM_KEYS.PROGRESS}
        rules={{ required: false, min: 0, max: 100 }}
        render={({ field: { value, ...field } }) => (
          <FormItem className='flex flex-col gap-2'>
            <FormLabel className='typography-overline text-text-secondary'>
              {t('global.workstream.labels.progress')}
            </FormLabel>
            <FormControl>
              <TextInput
                type='number'
                value={value}
                placeholder={t('global.workstream.placeholders.progress')}
                {...field}
              />
            </FormControl>
            <FormDescription>{t('global.workstream.hints.progress')}</FormDescription>
            <FormMessage>{form.formState.errors.progress?.message}</FormMessage>
          </FormItem>
        )}
      />
    </Stack>
  );
};
